import { ref, watch } from 'vue'

export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'connect-theme'

const loadInitial = (): Theme => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw === 'light' || raw === 'dark') return raw
  } catch {}
  return 'dark'
}

export const theme = ref<Theme>(loadInitial())

export const applyTheme = (value: Theme) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', value)
    document.body?.setAttribute('data-theme', value)
  }
}

watch(theme, (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, value)
  } catch {}
  applyTheme(value)
})

export const toggleTheme = () => {
  theme.value = theme.value === 'dark' ? 'light' : 'dark'
}
